import React, { useEffect, useState } from "react";
import { Card, Table, message } from "antd";

import ReportFilterBar from "../components/ReportFilterBar";
import ReportExportButton from "../components/ReportExportButton";
import { fetchEmployeeActivityReportApi } from "../../../apiservice/crm";

const formatDuration = (seconds) => {
  const total = Number(seconds || 0);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return [h, m, s].map((v) => String(v).padStart(2, "0")).join(":");
};

const EmployeeActivityReport = () => {
  const [filters, setFilters] = useState({});
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async (nextFilters = filters) => {
    setLoading(true);
    try {
      const res = await fetchEmployeeActivityReportApi(nextFilters);
      setData(res.data?.data || []);
    } catch (err) {
      message.error(err?.response?.data?.message || "Failed to load employee activity report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const columns = [
    { title: "Employee", dataIndex: "full_name" },
    { title: "Calls Logged", dataIndex: "calls_logged", align: "center" },
    { title: "Call Duration", dataIndex: "call_seconds", align: "center", render: formatDuration },
    { title: "Leads Touched", dataIndex: "leads_touched", align: "center" },
    { title: "Field Edits", dataIndex: "field_edits", align: "center" },
  ];

  return (
    <>
      <ReportFilterBar
        filters={filters}
        onChange={(partial) => setFilters((f) => ({ ...f, ...partial }))}
        onApply={() => load()}
        onReset={() => {
          setFilters({});
          load({});
        }}
        loading={loading}
      />

      <Card title="Employee Activity & Calls" extra={<ReportExportButton reportType="employee-activity" filters={filters} />}>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={data}
          loading={loading}
          bordered
          scroll={{ x: "max-content" }}
        />
      </Card>
    </>
  );
};

export default EmployeeActivityReport;
